export enum PlayerStatusEnum {
  Retired = "0",
  Active = "1",
}
